var map = {
	"./TCS.jpg": 128,
	"./TCS.jpg:Zone.Identifier": 129,
	"./address_image.svg": 130,
	"./animated_ashutosh.png": 131,
	"./animated_logo.svg": 132,
	"./arun.jpg": 133,
	"./aws.png": 134,
	"./blogs_image.svg": 135,
	"./cloud_infrastructure.svg": 136,
	"./codeInLogo.png": 137,
	"./contactMail.png": 138,
	"./coursera_logo.png": 139,
	"./data_science.svg": 140,
	"./deeplearning_ai_logo.png": 141,
	"./delhivery_logo.png": 142,
	"./developerActivity.svg": 143,
	"./dsc_logo.png": 144,
	"./education.svg": 145,
	"./experience.svg": 146,
	"./feelingProud.svg": 147,
	"./freecopy_logo.png": 148,
	"./fullstack.svg": 149,
	"./gcp_logo.png": 150,
	"./github_logo.png": 151,
	"./googleAssistant.jpg": 152,
	"./googleAssistant.svg": 153,
	"./google_logo.png": 154,
	"./ibm_logo.png": 155,
	"./intel_logo.jpg": 156,
	"./iu_logo.png": 157,
	"./jsFramework.svg": 158,
	"./legato_logo.png": 159,
	"./manOnTable.svg": 160,
	"./microsoft_logo.png": 161,
	"./mozilla_logo.png": 162,
	"./muffito_logo.png": 163,
	"./nextuLogo.jpg": 164,
	"./nptel_logo.png": 165,
	"./ovgu.jpg": 166,
	"./portfolio.gif": 167,
	"./programmer.svg": 168,
	"./projects_image.svg": 169,
	"./pwa.png": 170,
	"./saayaHealthLogo.png": 171,
	"./stanford_logo.png": 172,
	"./talksCardBack.svg": 173,
	"./talksCardBackAlt.svg": 174,
	"./tiktok_logo.png": 175,
	"./ui_ux_design.svg": 176,
	"./vit.png": 177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;